var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

var { COLORS, classify, makeTranslate, wrapText, formatStyle } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");

// Render a stacked bar chart.
module.exports = function(config) {
  // Setup
  var { labelColumn} = config;

  var barHeight = 30;
  var barGap = 5;
  var labelWidth = 60;
  var labelMargin = 10;
  var groupLabelWidth = 90;
  var valueGap = 6;

  var margins = {
    top: 0,
    right: 20,
    bottom: 20,
    left: (groupLabelWidth + labelMargin + labelWidth + labelMargin)
  };

  var ticksX = 4;
  var roundTicksFactor = 100;

  if (isMobile.matches) {
    ticksX = 2;
  }

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = (barHeight + barGap) * config.data.length;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // console.log(window.LABELS.headline_1);
  if (config.title == "DTrump" && config.showTitle) {
    containerElement.append('h1')
      .html(window.LABELS.headline_1);
  } else if (config.title == "RDeSantis" && config.showTitle) {
    containerElement.append('h1')
      .html(window.LABELS.headline_2);
  }

  var values = config.data.map(d => d.values[d.values.length - 1].x1);
  var floors = values.map(
    v => Math.floor(v / roundTicksFactor) * roundTicksFactor
  );
  var ceilings = values.map(
    v => Math.ceil(v / roundTicksFactor) * roundTicksFactor
  );

  var min = Math.min(...floors);
  var max = Math.max(...ceilings);

  if (min > 0) {
    min = 0;
  }

  var xScale = d3
    .scaleLinear()
    .domain([min, max])
    .rangeRound([0, chartWidth]);

  var yScale = d3
    .scaleBand()
    .domain(config.data.map(d => d.category))
    .range([0, chartHeight])
    .padding(0.1);

  var yScaleBars = d3
    .scaleBand()
    .domain(config.data.map(d => d[labelColumn]))
    .range([0, yScale.bandwidth()])
    .padding(0.1);

  var colorScale = d3
    .scaleOrdinal()
    .domain(config.data[0].values.map(d => d[labelColumn]))
    .range([COLORS.teal3, "#bababa", COLORS.orange3]);

  // Render the legend.
  var legend = containerElement
    .append("ul")
    .attr("class", "key")
    .selectAll("g")
    .data(colorScale.domain())
    .enter()
    .append("li")
    .attr("class", (d, i) => `key-item key-${i} ${classify(d)}`);

  legend.append("b").style("background-color", colorScale);

  legend.append("label").text(d => d);

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 axes.
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .ticks(ticksX)
    .tickFormat(d => d + "%");
  
  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .tickFormat(d => d);

  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  // Render grid to chart.
    chartElement
    .append("g")
    .attr("class", "x grid")
    //.attr("dx", 10)
    .attr("transform", makeTranslate(0, chartHeight))
    .call(
      xAxis
        .tickSize(-chartHeight, 0, 0)
        .tickFormat("")
    );

  // Render bars to chart.
  yScale.domain().forEach(function(c, k) {
    // console.log(c);
    var categoryElement = chartElement.append("g")
      .attr("class", classify(c))
      .attr("transform", d => makeTranslate(0, yScale(c)));

    // category label
    categoryElement.append("text")
      .attr("class", "category label")
      .attr("x", -margins.left)
      .attr("y", 0)
      .attr("dy", (barHeight / 2) + 4)
      .text(c)
      .call(wrapText, groupLabelWidth, 14);

    var columns = categoryElement
      .selectAll(".columns")
      .data(config.data.filter(d => d.category == c))
      .enter()
      .append("g")
      .attr("class", "column")
      .attr("transform", d => makeTranslate(0, yScaleBars(d[labelColumn])));

    // bar labels
    columns.append("text")
      .attr("class", "label")
      .text(d => d[labelColumn])
      .attr("x", -labelMargin)
      .attr("dy", (barHeight / 2) + 2)

    // bar segments
    var bars = columns
      .append("g")
      .attr("class", "bar");

  bars
    .selectAll("rect")
    .data(d => d.values)
    .enter()
    .append("rect")
    .attr("x", d => (d.x0 < d.x1 ? xScale(d.x0) : xScale(d.x1)))
    .attr("width", d => Math.abs(xScale(d.x1) - xScale(d.x0)))
    .attr("height", yScaleBars.bandwidth())
    .style("fill", d => colorScale(d[labelColumn]))
    .attr("class", d => classify(d[labelColumn]));

  // Render bar values.
  bars
    .selectAll("text")
    .data(d => d.values)
    .enter()
    .append("text")
    .text(d => (d.val ? d.val + "%" : null))
    .attr("class", d => classify(d.name))
    .attr("x", d => xScale(d.x1))
    .attr("dx", function(d) {
      var textWidth = this.getComputedTextLength();
      var barWidth = Math.abs(xScale(d.x1) - xScale(d.x0));

      // Hide labels that don't fit
      if (textWidth + valueGap * 2 > barWidth) {
        d3.select(this).classed("hidden", true);
      }

      if (d.x1 < 0) {
        return (valueGap + textWidth);
      }

      return -valueGap;
    })
    .attr("dy", barHeight / 2 + 2);
  });


  // Render 0-line.
  if (min < 0) {
    chartElement
      .append("line")
      .attr("class", "zero-line")
      .attr("x1", xScale(0))
      .attr("x2", xScale(0))
      .attr("y1", 0)
      .attr("y2", chartHeight);
  }
};
